import React from "react";
import Header from "./components/Header";
import Works from "./components/Works";
import { Box } from "@chakra-ui/react";
import Success from "component/home/component/Success";
import Footer from "component/header/Footer";
import useScrollAnimation from "component/useScrollAnimation";

function OurWork() {
  useScrollAnimation();
  return (
    <>
     <Box bg="#F5F5F5">
      <Header />

      <Works />

      <Box bg="#F7EAD9" pt={20} position="relative" borderBottomRadius="1rem">
        
      </Box>

      <Box bg="#F7EAD9">
        <Success />
        <Footer />
      </Box>
      </Box>
    </>
  );
}

export default OurWork;
